import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'How It Works', href: '#how-it-works' },
  { label: 'Testimonials', href: '#testimonials' },
  { label: 'Pricing', href: '#pricing' },
];

const scrollTo = (href: string) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

export default function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-white/96 backdrop-blur-md border-b border-stone-100' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        {/* Logo */}
        <a
          href="#home"
          onClick={(e) => { e.preventDefault(); scrollTo('#home'); }}
          className="font-serif text-2xl tracking-widest cursor-pointer"
          style={{ fontFamily: "'Cormorant Garamond', serif", color: scrolled ? '#2C2C2C' : '#ffffff', letterSpacing: '0.18em' }}
        >
          Dreamline Bridal
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
              className={`text-sm tracking-widest uppercase cursor-pointer transition-all duration-300 hover:opacity-60 whitespace-nowrap ${
                scrolled ? 'text-stone-600' : 'text-white/90'
              }`}
              style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.7rem', letterSpacing: '0.15em' }}
            >
              {link.label}
            </a>
          ))}
          <button
            onClick={() => scrollTo('#consultation')}
            className={`whitespace-nowrap px-6 py-2.5 text-xs tracking-widest uppercase transition-all duration-300 cursor-pointer rounded-sm ${
              scrolled
                ? 'bg-stone-800 text-white hover:bg-stone-700'
                : 'border border-white/80 text-white hover:bg-white/10'
            }`}
            style={{ fontFamily: "'DM Sans', sans-serif", letterSpacing: '0.12em' }}
          >
            Book Consultation
          </button>
        </div>

        {/* Mobile hamburger */}
        <button
          className={`md:hidden w-8 h-8 flex flex-col justify-center gap-1.5 cursor-pointer`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span className={`block h-px transition-all duration-300 ${scrolled ? 'bg-stone-700' : 'bg-white'} ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} style={{ width: '24px' }} />
          <span className={`block h-px transition-all duration-300 ${scrolled ? 'bg-stone-700' : 'bg-white'} ${menuOpen ? 'opacity-0' : ''}`} style={{ width: '16px' }} />
          <span className={`block h-px transition-all duration-300 ${scrolled ? 'bg-stone-700' : 'bg-white'} ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} style={{ width: '24px' }} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white/98 backdrop-blur-md border-t border-stone-100 px-6 py-6 flex flex-col gap-5">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => { e.preventDefault(); scrollTo(link.href); setMenuOpen(false); }}
              className="text-stone-600 text-sm tracking-widest uppercase cursor-pointer"
              style={{ fontFamily: "'DM Sans', sans-serif", letterSpacing: '0.12em' }}
            >
              {link.label}
            </a>
          ))}
          <button
            onClick={() => { scrollTo('#consultation'); setMenuOpen(false); }}
            className="w-full py-3 bg-stone-800 text-white text-xs tracking-widest uppercase cursor-pointer rounded-sm whitespace-nowrap"
            style={{ fontFamily: "'DM Sans', sans-serif", letterSpacing: '0.12em' }}
          >
            Book Consultation
          </button>
        </div>
      )}
    </nav>
  );
}
